import React, { useId } from 'react';

import { Box, Typography } from '@mui/material';

const sites = ['Branded site A', 'Branded site B', 'Additional branded sites'];

function MultiSiteDiagram() {
  const captionId = useId();
  return (
    <Box
      component='figure'
      aria-labelledby={captionId}
      sx={{ m: 0, mt: 4, p: { xs: 2.5, md: 4 }, borderRadius: 3, bgcolor: '#EDF5F8' }}
    >
      <Typography
        variant='overline'
        sx={{ color: '#075582', fontWeight: 700 }}
      >
        Multi-site publishing
      </Typography>
      <Typography
        component='p'
        variant='h5'
        sx={{ mt: 0.5, fontWeight: 700, color: '#0B2545' }}
      >
        One shared system. Distinct sites.
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 0.9fr) minmax(0, 1.1fr)' },
          gap: { xs: 2, md: 4 },
          alignItems: 'center',
          mt: 3,
        }}
      >
        <Box sx={{ p: 3, borderRadius: 3, bgcolor: '#0B2545', color: '#FFFFFF' }}>
          <Typography
            component='p'
            variant='h6'
            sx={{ fontWeight: 700, color: '#FFFFFF' }}
          >
            Shared CMS
          </Typography>
          <Box
            component='ul'
            sx={{ mb: 0, pl: 2.5, lineHeight: 1.8 }}
          >
            <li>One codebase and reusable templates</li>
            <li>Role-based editorial access</li>
            <li>English, Spanish, and French</li>
          </Box>
        </Box>
        <Box
          component='ul'
          role='list'
          aria-label='Example branded sites'
          sx={{ listStyle: 'none', m: 0, p: 0, display: 'grid', gap: 1.5 }}
        >
          {sites.map((site) => (
            <Box
              component='li'
              key={site}
              sx={{
                px: 2.5,
                py: 2,
                border: '1px solid #BDD4DF',
                borderLeft: '5px solid #007BA6',
                borderRadius: 2,
                bgcolor: '#FFFFFF',
              }}
            >
              <Typography
                component='p'
                sx={{ fontWeight: 700, color: '#0B2545' }}
              >
                {site}
              </Typography>
              <Typography
                component='p'
                sx={{ color: '#475569' }}
              >
                Site-specific content and navigation
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Typography
        component='figcaption'
        id={captionId}
        sx={{ mt: 3, color: '#334155' }}
      >
        Illustrative view of a delivered publishing pattern; not a client interface or exact site
        count.
      </Typography>
    </Box>
  );
}

export default MultiSiteDiagram;
